import React, { Component } from "react";
import Home from "./components/home/home";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import {EmailActivation} from './components/accounts/Activation/emailactivation';
import { MobileActivation } from './components/accounts/Activation/mobileactivation'; 
import {EditProfile} from './components/profile/editprofile';
import SingleTournament from './components/Tournament/singletournament';
export default class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
       
            <Route exact path="/"  render={ props => <Home {...props} />}  />
            <Route path="/emailverification"   render={ props => <EmailActivation {...props} />} />
            <Route path="/mobileverification"   render={ props => <MobileActivation {...props} />} />
            <Route  path = "/editprofile" render={ props => <EditProfile {...props} />} />
            <Route  path = "/singletournament" render={ props => <SingleTournament {...props} />} />
         
        </Router>
      </div>
    );
  }
}
